module.exports = ".mat-column-recibido {\n  flex: 0 0 10%; }\n\n.mat-column-requisito {\n  flex: 0 0 87%;\n  padding: 10px; }\n"